"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _DataTableInfiniteScroll = _interopRequireDefault(require("../../../../../data-table-infinite-scroll/DataTableInfiniteScroll"));

var _actions = require("../../../../../policy/Members/actions");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TagMembers = function TagMembers(_ref) {
  var tagId = _ref.tagId;
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_DataTableInfiniteScroll.default, {
    dataUrl: "/api/user-tags/".concat(tagId, "/users?fetchDynamicallyAssignedUsers=true"),
    dispatchAction: _actions.getTagMembersRequest,
    stateDataPath: "membersReducer.tagMembers",
    withPaginationUrl: false,
    columns: [{
      field: 'name',
      headerName: 'Name'
    }, {
      field: 'email',
      headerName: 'Email'
    }, {
      field: 'username',
      headerName: 'User Name'
    }, {
      field: 'status',
      headerName: 'Status'
    }]
  }));
};

TagMembers.propTypes = {
  tagId: _propTypes.default.string
};
var _default = TagMembers;
exports.default = _default;